module.exports = __webpack_public_path__ + "img/Jamaica.89fc0a62.svg";